import { useQuery } from "@tanstack/react-query";
import {
  fetchProtocolStatusInsights,
  fetchTrialExecutionInsights,
  type InsightsDatum,
  type ProtocolInsightsParams,
} from "./protocolInsightsService";

interface UseSummaryInsightsResult {
  protocolInsights?: InsightsDatum[];
  trialInsights?: InsightsDatum[];
  isLoading: boolean;
  isError: boolean;
}

export const useSummaryInsights = (
  params: ProtocolInsightsParams
): UseSummaryInsightsResult => {
  const enabled = !!(params.orgId || params.workspaceId);

  const queryKeyParams = [
    params.orgId,
    params.workspaceId,
    params.isWorkspace,
    params.archived,
    params.search,
    params.status,
    params.advancedFilters,
  ];

  const protocolQuery = useQuery({
    enabled,
    queryKey: ["summaryInsights", "protocols", ...queryKeyParams],
    queryFn: async () => await fetchProtocolStatusInsights(params),
  });

  const trialQuery = useQuery({
    enabled,
    queryKey: ["summaryInsights", "trials", ...queryKeyParams],
    queryFn: async () => await fetchTrialExecutionInsights(params),
  });

  return {
    protocolInsights: protocolQuery.data,
    trialInsights: trialQuery.data,
    isLoading: enabled && (protocolQuery.isLoading || trialQuery.isLoading),
    isError: protocolQuery.isError || trialQuery.isError,
  };
};
